// extracted by mini-css-extract-plugin
export var wrap = "resource-center-post-module--wrap--66cvz";
export var wrap_aside = "resource-center-post-module--wrap_aside--16h0k";
export var wrap_content = "resource-center-post-module--wrap_content--36a-Q";
export var postInfo = "resource-center-post-module--postInfo--1k2qH";